import { FC } from 'react';
import { Container, Stack, Typography, Button } from '@mui/material';


interface DesktopMessageProps {
    onContinueToDesktop: () => void;
}

export const DesktopMessage: FC<DesktopMessageProps> = (props) => {
  const { onContinueToDesktop } = props;
  return (
    <Container maxWidth="sm" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
      <Stack spacing={2} alignItems="center">
        <Typography variant="h5" align="center" gutterBottom>
          Open this page on your mobile device or tablet.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={onContinueToDesktop}
        >
            Continue on Desktop anyways
        </Button>
      </Stack>
    </Container>
  );
};
